import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    grow: { flexGrow: 1 },
    header: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        flexShrink: 1,
        flexBasis: 'auto',
        padding: '.5rem 1rem'
    },
    gridContainer: {
        borderTop: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter ||
        '#cfcfcf'}`
    },
    userDetailsContainer: { padding: '2.5rem 3rem' },
    noSelectedUser: {
        paddingTop: '3rem',
        alignSelf: 'center' as const,
        justifySelf: 'center' as const
    },
    usersIcon: {
        height: '90px',
        width: '90px',
        paddingBottom: '.5rem'
    },
    btnRequestContainer: {
        display: 'flex' as const,
        alignItems: 'center' as const
    },
    btnRequest: {
        height: '28px',
        background: '#E68856',
        color: '#fff',
        fontSize: '14px',
        fontWeight: 'normal' as const,
        padding: '17px',
        textTransform: 'capitalize' as const,
        margin: '10px -1rem',
        '&:hover': {
            background: '#fff',
            color: '#E68856',
            borderColor: '#E68856',
            border: '2px solid'
        }
    }
});